module.exports = __webpack_public_path__ + "media/newstyle/images/icon-print-c3fca98717a8f5d5972f13128d9e789a.svg";